import { createContext } from 'react'
import type { Preferences } from '@/features/preferences/types'

export type SessionStatus = 'loading' | 'authenticated' | 'anonymous' | 'error'

export const sessionQueryKey = ['session'] as const

/**
 * 마지막 확인에서 이 시간이 지나지 않았으면 다시 묻지 않는다.
 * 앱을 열 때와 창이 앞으로 나올 때, 화면을 옮길 때가 모두 이 값을 함께 쓴다.
 */
export const SESSION_STALE_TIME_MS = 60_000

export interface SessionContextValue {
  status: SessionStatus
  /** 계정에 남은 화면 설정. 아직 받지 못했으면 없다. */
  preferences: Preferences | null
  /** 살아 있던 Session이 이번 방문 중에 끊겼는지. 처음부터 없던 것과 가른다. */
  expired: boolean
  refresh: () => void
}

export const SessionContext = createContext<SessionContextValue | null>(null)
